/**
 * module index, please access all functionalities from here
 */
import WordPartDeletion from './WordPartDeletion'

export default WordPartDeletion